"use client";

import { useState } from "react";

import MessageBarContext from "@repo/ui/contexts/MessageBarContext";

export default function MessageBarProvider({ children }: { children: React.ReactNode }) {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <MessageBarContext.Provider value={{ isVisible, setIsVisible }}>
      {children}
    </MessageBarContext.Provider>
  );
}
